<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserRecycleViewPage',
  isAutoComponent: true,
  data() {
    return {
      props: { multiple: true, children: 'children', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' },
      options: [],
      detailForm: {
        title: '回收站人员详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '账号',
            key: 'userName',
            type: 'text',
            required: false,
            disabled: true },
          // { name: '站点',
          //   key: 'siteIds',
          //   type: 'custom',
          //   required: false,
          //   disabled: true },
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: false,
            disabled: true },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: false,
            disabled: true }]
      },
      detailFormButtons: {
        title: '回收站人员详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      checkList: []
    }
  },
  created() {
  },
  mounted() {
    const siteIds = []
    for (const item of this.detailFormData.siteList) {
      siteIds.push(item.id)
    }
    this.detailFormData.siteIds = siteIds
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userRecycle.userRecycleDetailData
    })
  }
}
</script>

<style scoped>
.action-check-group {
  padding-left: 180px;
}
.action-check-group .el-checkbox {
  margin-bottom: 8px;
}
</style>
